import { render, staticRenderFns } from "./CertificationsDialog.vue?vue&type=template&id=acb48452&scoped=true&"
import script from "./CertificationsDialog.vue?vue&type=script&lang=js&"
export * from "./CertificationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsDialog.vue?vue&type=style&index=0&id=acb48452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb48452",
  null
  
)

export default component.exports